import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { useLiquidity } from "../../hooks/useLiquidity";
import { formatCompactNumber } from "../../utils/common";

const AllPoolsCard = ({ t1, t2, pairs, totalLiq, poolAPR }: any) => {

  useEffect(() => {
    const getPools = async () => {
      // const { totalAmount } = await getPoolTotalAmount(pairs.pair_name);
      // setTotalLiq(totalAmount);
      // const poolAPR = await getPoolAPR(pairs.pair_name);
      // setPoolAPR(poolAPR.apr);
    };
    getPools();
  }, []);
  const display = pairs.pair_type === "stable";
  return (
    <div className="card">
      <div className="card-image">
        <div className="overlapping-images">
          <img src={t1?.logo_URIs.png} alt="" height={50} width={50} />
          <img
            className="logo-overlap"
            src={t2?.logo_URIs.png}
            alt=""
            height={50}
            width={50}
          />
        </div>
        <div className="pair_name">
          <div>
            {t1.display_denom} / {t2.display_denom}
          </div>
          {display ? (
            <div className="display-tag">
              <span>stable</span>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
      {/* <div className="card-content">
        <span>Total Liquidity</span>
        <p className="numeric-font">${totalLiq}</p>
      </div> */}
      <div className="card-bottom">
        <div>
          <span>Liquidity</span>
          {/* <p className="numeric-font">${totalLiq}</p> */}
          <p className="numeric-font">${formatCompactNumber(totalLiq)}</p>
        </div>
        <div>
          <span>APR</span>
          <p className="numeric-font">{Number(poolAPR) 
          ?
          poolAPR + "%"
          :
          "0.00 %"}</p>
        </div>
      </div>
    </div>
  );
};

export default AllPoolsCard;
